var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gj-select',_vm._g(_vm._b({attrs:{"select-all-node":"","show-checkbox":_vm.multiple,"multiple":_vm.multiple,"type":_vm.multiple ? 'multi-check' :'default',"options":_vm.operationStateReverse}},'gj-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }